import MediaFile from 'models/core/mediaFile/Model.MediaFile';
import Model from 'models/Model';
import Contract from 'models/sales/contract/Model.Contract';

export default class ContractDocumentAggregateTranslation
  extends Model<Model.IContractDocumentAggregateTranslation>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IContractDocumentAggregateTranslation>
{
  id: number;
  languageIsoCode: Locale.Languages;
  mediaFileId: number;
  mediaFile: MediaFile;
  contractId: number;
  contract: Contract;

  constructor(
    data:
      | Partial<Model.IContractDocumentAggregateTranslation>
      | Utils.FormData<Model.IContractDocumentAggregateTranslation>,
    language?: Locale.Languages
  ) {
    super(
      {
        mediaFile: MediaFile,
        contract: Contract,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: `${this?.mediaFile?.name}` || this.id.toString(),
      subtitle: this.contract?.appNumber,
    };
  }
}
